export default "__VITE_ASSET__FFrv_gqf__"